export default ({ data }) => {
  return data.reduce((errors, error) => ({
    ...errors,
    [error.field]: error.message
  }), {})
}